<template>
  <a
    :class="{dark: isDark, [size]: size, custom: customLogo}"
    :href="linkTo"
    :title="(customLogo && customLogo.link) || 'Simplecast Homepage'"
    class="logo"
    target="simplecast"
  >
    <img
      v-if="customLogo"
      :src="isDark ? customLogo.logoDark : customLogo.logo"
      class="custom-logo">
    <IconLogo v-else />
  </a>
</template>

<script>
import IconLogo from '../assets/svg/sc-logo.svg'

export default {
  components: { IconLogo },
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  data () {
    return {
      customLogo: null
    }
  },
  computed: {
    isDark () { return this.store.state.isDark },
    size () { return this.store.state.size },
    podcastId () {
      if (!this.store.state.podcast) { return null }
      const pid = this.store.state.podcast.id
      if (pid) { return pid }
      if (!this.store.state.podcast.href) { return null }
      // This is ridiculous, tbh. Why isn't the podcast ID returned for a playlist player?
      const reg = /podcasts\/(.*)\//
      const matched = this.store.state.podcast.href.match(reg)
      return matched[1] || null
    },
    linkTo () {
      return (this.customLogo && this.customLogo.link) || 'https://simplecast.com'
    }
  },
  watch: {
    podcastId (val, old) {
      // Once the API returns custom logo stuff with the Podcast object, this code can be removed!
      if (val && val !== old) {
        this.store.getCustomLogo(val)
          .then(logo => {
            this.customLogo = logo
          })
      }
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';

.sc-logo {
  g {
    fill: $black-800;
  }
}
.dark .sc-logo {
  g {
    fill: $white-000;
  }
}
</style>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints.scss';

.logo {
  box-sizing: content-box;
  padding: 8px;
  height: 20px;
  right: 0;
  top: 0;
  width: 20px;
  z-index: 100;

  @media (min-width: $bp_xs) {
    padding: 14px;
  }
  @media (min-width: $bp_sm) {
    padding: 16px;
  }
  opacity: .1;
  position: absolute;
  z-index: 100;

  &.dark {
    opacity: .2;
  }

  &.custom {
    opacity: 1;
    width: auto;
    height: auto;
  }

  svg {
    height: 100%;
    width: 100%;
  }

  .custom-logo {
    max-width: 30px;
    max-height: 50px;
  }
}
.size-mini {
  display: none;
}
</style>
